export const getters = {
  getQueues($state) {
    return Object.values($state.records).sort((a, b) => a.id - b.id);
  },
  // Queues the current agent can pull from (member via primary/overflow group).
  getMyQueues($state, $getters) {
    return $getters.getQueues.filter(queue => queue.is_member);
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getQueue: $state => id => {
    const queue = $state.records[id];
    return queue || {};
  },
};
